const WALK_KMH = 4.8;
const RIDE_KMH = 22;
const WALK_LIMIT_KM = 1.6;

export function haversineKm(a, b) {
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLon = toRad(b.lon - a.lon);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export function legBetween(a, b) {
  if (!a?.lat || !b?.lat) return null;
  const km = haversineKm(a, b);
  const walkMin = Math.max(1, Math.round((km / WALK_KMH) * 60));
  const rideMin = Math.max(3, Math.round((km / RIDE_KMH) * 60) + 4);
  const mode = km <= WALK_LIMIT_KM ? "walk" : "ride";
  return { km, minutes: mode === "walk" ? walkMin : rideMin, mode, walkMin, rideMin };
}

export function formatDistance(km) {
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`;
}

export function legsForStops(stops) {
  return stops.slice(1).map((s, i) => legBetween(stops[i], s));
}

export function nightSummary(stops) {
  const legs = legsForStops(stops).filter(Boolean);
  if (!legs.length) return null;
  const totalMin = legs.reduce((n, l) => n + l.minutes, 0);
  const totalKm = legs.reduce((n, l) => n + l.km, 0);
  const allWalk = legs.every((l) => l.mode === "walk");
  return { totalMin, totalKm, allWalk, rides: legs.filter((l) => l.mode === "ride").length };
}
